module.exports = __webpack_public_path__ + "static/ace_rewards_prefooter_mobile-28422f666bd03e115f016fff0b6c3ae2.jpg";